import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatError, MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'mng-inputfield-email',
  imports: [MatFormField, MatLabel, MatPrefix, NgStyle, ExtendedModule, MatInput, ReactiveFormsModule, MatError],
  template: `
    <mat-form-field
      style="width: 100%; {{ inputTextStyle() }}"
      [ngStyle]="ngStyle()"
      [appearance]="appearance()"
      [subscriptSizing]="subscriptSizing()"
      [floatLabel]="floatLabel()"
    >
      @if (field().label) {
        <mat-label>{{ field().label }}</mat-label>
      }
      <input
        [id]="field().id"
        type="email"
        matInput
        [formControl]="field().control"
        [placeholder]="field().placeHolder"
        autocomplete="off"
        style="{{ inputTextStyle() }}"
      />
      @if (iconName()) {
        <span matIconPrefix>&nbsp; <i class="fa {{ iconName() }} fa-1x"></i>&nbsp;&nbsp; </span>
      }
      @if (hasErrors) {
        <mat-error> {{ validationMessage }} </mat-error>
      }
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldEmailComponent extends InputFieldBaseComponent {}
